(function() {
    const root = document.getElementById('banner-slider-{{ section.id }}');
    if (!root) return;
    const track = root.querySelector('[data-track]');
    const btnPrev = root.querySelector('[data-prev]');
    const btnNext = root.querySelector('[data-next]');
    if (!track) return;

    const slideWidth = () => track.clientWidth;
    const maxIndex = Math.max(0, track.children.length - 1);
    const currentIndex = () => Math.round(track.scrollLeft / slideWidth());
    const snapTo = (index) => track.scrollTo({ left: Math.max(0, Math.min(index, maxIndex)) * slideWidth(), behavior: 'smooth' });

    btnPrev && btnPrev.addEventListener('click', () => snapTo(currentIndex() - 1));
    btnNext && btnNext.addEventListener('click', () => snapTo(currentIndex() + 1));
})();